import { Component } from '@angular/core'

import { LeaseDetailService } from '../../data/services/view/lease-detail.service'

/**
 * ADR-0021 — Render read-only de los flujos bancarios del TITULAR.
 * Los datos vienen del Excel via `risk-excel-upload`. Sin formularios de captura.
 */
@Component({
	selector: 'app-bank-flows-holder',
	templateUrl: './bank-flows-holder.component.html',
	styleUrls: ['./bank-flows-holder.component.scss'],
})
export class BankFlowsHolderComponent {
	constructor(public leaseDetailService: LeaseDetailService) {}

	get holderFlows(): any[] {
		const hb = this.leaseDetailService.holderBankFlows
		return Array.isArray(hb?.flows) ? hb.flows : []
	}

	get averageCashFlow(): number | null {
		const hb = this.leaseDetailService.holderBankFlows
		return typeof hb?.averageCashFlow === 'number' ? hb.averageCashFlow : null
	}

	get hasData(): boolean {
		return this.holderFlows.length > 0
	}
}
